<template>
  <div
    v-if="filterDefaultOptions.length > 0"
    class="card-filter-defaults"
  >
    <div>
      <el-button
        class="mb-s mr-s"
        :type="filterDefault === 'all' ? 'primary' : ''"
        @click="() => handleClickFilter('all')"
      >
        Tất cả ({{ allCount }})
      </el-button>
      <el-button
        v-for="c in filterDefaultOptions"
        :key="c.id"
        class="mb-s ml-0 mr-s"
        :type="filterDefault === c.id ? 'primary' : ''"
        @click="() => handleClickFilter(c.id)"
      >
        {{ c.extra.name }} ({{ counts[c.id] || 0 }})
      </el-button>
      <el-button
        class="mb-s ml-0 mr-s"
        :type="filterDefault === 'none' ? 'primary' : ''"
        @click="() => handleClickFilter('none')"
      >
        Chưa nhập liệu ({{ counts.none || 0 }})
      </el-button>
    </div>
  </div>
</template>

<script>
import documentUtilServices from "@/services/document-util";

export default {
  name: "CardFilterDefault",
  props: {
    config: Object,
    objectType: Object,
    moduleInfo: Object,
    moduleField: Object,
    filterDefault: String,
    filterDefaultKey: String,
    filterDefaultOptions: Array,
  },
  data() {
    return {
      counts: {}
    };
  },
  computed: {
    currentCountPayload() {
      if (this.moduleInfo && this.moduleField) {
        return [
          {
            document_key: this.objectType.role_action,
            filters: {
              type: this.config.extra.key,
              [`extra.${this.filterDefaultKey}`]: null,
              [`extra.${this.moduleField.key}`]: this.moduleInfo.key,
            },
            query_id: 'none'
          },
          ...this.filterDefaultOptions.map((c) => {
            return {
              document_key: this.objectType.role_action,
              filters: {
                type: this.config.extra.key,
                [`extra.${this.filterDefaultKey}`]: c.id,
                [`extra.${this.moduleField.key}`]: this.moduleInfo.key,
              },
              query_id: c.id
            }
          })
        ]
      }
      return [
        {
          document_key: this.objectType.role_action,
          filters: {
            type: this.config.extra.key,
            [`extra.${this.filterDefaultKey}`]: null,
          },
          query_id: 'none'
        },
        ...this.filterDefaultOptions.map((c) => {
          return {
            document_key: this.objectType.role_action,
            filters: {
              type: this.config.extra.key,
              [`extra.${this.filterDefaultKey}`]: c.id,
            },
            query_id: c.id
          }
        })
      ]
    },
    allCount() {
      return this.currentCountPayload.map((c) => this.counts[c.query_id] || 0).reduce((a, b) => a + b, 0)
    }
  },
  watch: {
    currentCountPayload: "getObjectCountData",
  },
  mounted() {
    this.getObjectCountData();
  },
  methods: {
    handleClickFilter(categoryId) {
      this.$router.push({ name: this.$route.name, params: this.$route.params, query: { filter_default: categoryId }})
    },
    async getObjectCountData() {
      if (this.currentCountPayload.length > 0) {
        documentUtilServices.post_count({
          items: this.currentCountPayload,
        }).then((res) => {
          const counts = {}
          this.currentCountPayload.forEach(p => {
            counts[p.query_id] = res.counts[`${p.document_key}_${p.query_id}`]
          });
          this.counts = counts
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  font-weight: 600 !important;
  border-color: rgba(0, 0, 0, 0.347);
}
</style>
